import type { ObjectId } from '@lmc/ts-common'
import { postJSON } from 'common/services/api'
import { useMutation, useQueryClient } from 'react-query'
import {
  ALLOCATION_TEMPLATE_CREATE_QUERY_KEY,
  ALLOCATION_TEMPLATE_CREATE_URL,
  ALLOCATION_TEMPLATE_LIST_QUERY_KEY
} from './queryConstants'

type AllocationTemplateCreateReturn = {
  createAllocationTemplate: (
    values: AllocationTemplateCreatePaylaod
  ) => Promise<unknown>
  isLoading: boolean
}

type AllocationTemplateCreatePaylaod = {
  templateAlias: string
  rotaId?: ObjectId
  startDate?: string
  overwrite?: boolean
}

const useAllocationTemplateCreate = (): AllocationTemplateCreateReturn => {
  const queryClient = useQueryClient()

  const createEventsFunction = async (
    values: AllocationTemplateCreatePaylaod
  ): Promise<unknown> => {
    return postJSON({
      url: ALLOCATION_TEMPLATE_CREATE_URL,
      method: 'POST',
      isRota: true,
      json: values
    })
  }

  const { mutateAsync: createAllocationTemplateMutation, isLoading } =
    useMutation<unknown, unknown, AllocationTemplateCreatePaylaod, unknown>(
      [ALLOCATION_TEMPLATE_CREATE_QUERY_KEY],
      createEventsFunction,
      {
        onSuccess: () => {
          queryClient.invalidateQueries([ALLOCATION_TEMPLATE_LIST_QUERY_KEY])
        }
      }
    )

  const handleCreateAllocationTemplate = async (
    values: AllocationTemplateCreatePaylaod
  ) => {
    try {
      const result = await createAllocationTemplateMutation(values)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    createAllocationTemplate: handleCreateAllocationTemplate,
    isLoading
  }
}

export default useAllocationTemplateCreate
